export default {
  line: "Linya",
  language: "Wika",
  common: [
    "Mga online na serbisyo",
    "Kanselahin ang Suspensyon",
    "Kung gagastos ng 10,000 ₱ para makabili"
  ],
  informationHub: "Opisyal na Sentro ng SGM.",
  charitables:[//慈善
	  "Welcome to SGM.s's official information hub! 🌟 Your platform for transparent, authoritative information. Here, you can check our official certification certificates 📜, visit https://sgm.lol/ for comprehensive info 🌐, and follow our Telegram channel for the latest updates! 📲 Additionally, you'll find positive reviews of SGM.s from international media like Yahoo, The Associated Press, and Google! 📰 All of this will significantly boost your confidence in the SGM.s brand and its future development, helping you succeed in the shared mobility business and consistently earn substantial additional income! 💰🚀"
	  ],
  details:[
	  "Task unit price",
	  "Number of order",
	  "Daily income",
	  "level",
	  "Daily profit",
	  "Deposit",
	  "Deposit return date",
	  "days remaining",
	  "My SGM.s Level"
  ],  
  upload: [
    "Nag-a-upload...",
     "Maling format",
     "Matagumpay na na-upload",
     "Nabigo ang pag-upload"
  ],
  appMsg: [
   "Handa nang mag-download ng mga update...",
    "Kumpleto na ang pag-download, kung i-install ang package ng pag-update",
    "Nabigo ang pag-download ng pag-update",
    "{num}% ang na-download",
    "Nag-a-update...",
    "Ang pag-update ay matagumpay at malapit nang mag-restart",
    "Nabigo ang pag-update",
    "Pindutin muli upang lumabas sa application"
  ],
  vanPull: [
    "Wala nang data",
     "Walang data"
  ],
  login: {
    title:'Mag-login gamit ang username at password',
    title_txt:'Mag-log in gamit ang iyong rehistradong numero ng mobile phone',
    text: [
      "Tandaan ang username/password",
       "Pagtotroso...",
       "Mag-log in ngayon"
    ],
    placeholder: [
      "Pakilagay ang numero ng telepono",
       "Pakilagay ang password sa pag-login"
    ],
    i18n: [
     "Walang {title} account? {a} {line}",
      "Magparehistro"
    ]
  },
  register: {
    text: [
      "Maligayang pagdating sa pagrehistro",
       "Pagpapadala ng SMS code...",
       "Kumuha ng SMS code",
       "Nagrerehistro...",
       "Mag-rehistro na ngayon",
       "Magkaroon ng isang account, i-download ngayon",
       "Pagpaparehistro ng numero ng mobile phone",
       "Pagpaparehistro sa email",
        "Bumalik sa pag-login",
       "Mangyaring gumamit ng hindi rehistradong numero ng telepono at email address"
    ],
    placeholder: [
      "Pakibigay na lng po ng phone number niyo",
       "Pakilagay ang SMS verification code",
       "Pakilagay ang password sa pag-login",
       "Pakikumpirma ang iyong password",
       "Pakilagay ang code ng imbitasyon",
       "Magkaiba ang dalawang password",
       "Mangyaring ipasok ang verification code",
       "Pakilagay ang numero ng email",
	   "Hindi maaaring magsimula sa 0"
    ],
    i18n: [
      "May account? {a} {line}",
       "Mag log in"
    ]
  },
  footer: [
    "Bahay",
     "Gawain",
     "Chat",
     "T",
     "Aking",
     "Kita"
  ],
  home: {
    leval: "Leval",
    view:'lihat',
    myCoins: "Aking Balanse",
    broadcast: "Binabati kita sa miyembro: {member} para sa pagrekomenda sa {vipname} na sumali at makatanggap ng {currency}{grade} na bonus sa promosyon",
    menu: [
      "VIP area",
       "Video tutorial",
       "Mga gantimpala sa promosyon"
    ],
    taskHall: {
      title: [
        "Task hall",
         "Business Hall",
         "Kumpletuhin ang mga gawain upang kumita ng kita"
      ]
    },
    memberList: {
      title: "Listahan ng membership",
      data: [
        "{member},Kumpletuhin ang {num} iisang gawain ngayon at kumita ng {currency}{profit}!"
      ]
    },
    businessList: {
      title: "Listahan ng merchant",
      data: [
        "{member}",
        "Ilabas ang {num} iisang gawain ngayon"
      ]
    },
    noticeTitle: ["Pansinin","Nakaraang","Susunod"],
    tabBar: [
		"Bahay",
		  "Gawain",
		  "T",
		  "Kita",
		  "Aking"
    ],
    msg: "Ang gawain ay hindi bukas",
    video: "Walang video tutorial",
	message:"May bago kang balita",
	bonus:[
		'<p>Ilagay ang password para matanggap ang pulang sobre na cash reward.</p><p>1. Nakukuha ang password sa pamamagitan ng mga aktibidad ng kumpanya!</p><p>2. Ang grupong nagtatrabaho ay nagbibigay ng mga password paminsan-minsan! Maaari mong bigyang-pansin ang impormasyon ng working group araw-araw!</p><p>Para sa mga detalye, mangyaring kumonsulta sa "Recruitment Manager"</p>',
    'Ang password ay nakuha sa pamamagitan ng mga aktibidad ng kumpanya!',
		'Ilagay ang pulang Envelope code',
		'Tumanggap ng Pulang Sobre',
		'Congratulations sa pagkuha ng red envelope bonus na {amount}₱'
	],
    helpCenter: {
      title: "Help Center",
      empty: "No help articles"
    }
  },
  postTask: {
    navBar: {
      title: "Bitawan ang misyon",
      right: "Mga panuntunan sa pagpapalabas"
    },
    field: [{
        label: "Pag-uuri ng gawain",
      },
      {
        label: "Pamagat ng gawain",
        placeholder: "Mangyaring magpasok ng pamagat ng gawain",
        error: "Ang pamagat ng gawain ay hindi maaaring walang laman"
      },
      {
        label: "Maikling Gawain",
        placeholder: "Mangyaring magpasok ng paglalarawan ng gawain"
      },
      {
        label: "Presyo ng yunit ng gawain",
        placeholder: "Pakilagay ang presyo ng task unit",
        right: "{currency}",
        error: "Ang presyo ng unit ng gawain ay hindi maaaring walang laman"
      },
      {
        label: "Numero na natanggap",
        placeholder: "Mangyaring ipasok ang numero",
        error: "Ang dami ay hindi maaaring walang laman"
      },
      {
        label: "Bilang ng mga resibo",
        placeholder: "Pakilagay ang bilang ng mga resibo",
        right: "Oras/tao",
        error: "Hindi maaaring walang laman ang bilang ng mga resibo"
      },
      {
        label: "Kabuuang presyo ng gawain",
        error: "Ang kabuuang presyo ng gawain ay hindi kinakalkula"
      },
      {
        label: "I-link ang impormasyon",
        placeholder: "Pakilagay ang link address",
        error: "Hindi maaaring walang laman ang impormasyon ng link"
      },
      {
        label: "Antas ng gawain",
      },
      {
        label: "Deadline",
        placeholder: "I-click upang pumili ng petsa",
        error: "Hindi maaaring walang laman ang deadline"
      },
      {
        label: "Mga kondisyon ng pagkumpleto",
        error: "Mangyaring pumili ng kundisyon sa pagkumpleto"
      },
      {
        label: "Mga kinakailangan sa pag-upload",
        placeholder: "Pakipasok ang kahilingan sa pag-upload",
      },
      { 
        label: "Halimbawang pag-audit",
      },
      {
        label: "Hakbang",
        placeholder: "Madaling maunawaan ang mga hakbang ay makakatulong upang makumpleto!",
        error: "Ang hakbang sa pagpapatakbo ay hindi maaaring walang laman",
        img: "Ang diagram ng hakbang ay hindi perpekto"
      },
    ],
    button: "Ipasa",
    step: {
      title: "Hakbang",
      left: "Kanselahin",
      right: "Nakumpleto",
      placeholder: "Mangyaring magpasok ng paglalarawan ng hakbang",
      button: [
        "Tanggalin",
        "Idagdag"
      ]
    },
    tips: [
      "Bayad sa pangangasiwa sa platform {pump}{br}Ang release na ito ay mangangailangan ng pagbabayad ng humigit-kumulang {price},Pakitiyak na ang balanse ng account ay sapat {a}{br}Tip: Ipinagbabawal ng platform na ito ang pagpapalabas ng pornograpiya, pagsusugal, droga at lahat ng iba pang legal na ipinagbabawal na nilalaman, tulad ng mga deduction point, naka-block na account.",
      "Upang mag-recharge",
      "Panatilihin ang hindi bababa sa isang hakbang",
      "Magdagdag ng hanggang sampung hakbang"
    ]
  },
  vip: {
    title:[
      "antas ng VIP",
      "Sumali sa membership ngayon upang mag-claim ng mga gawain"
    ],
    user: {
      title: [
        "Ang iyong pagkakakilanlan",
        "Mga bisita"
      ],
      label: "Pang-araw-araw na gawain",
      value: [
        "Petsa ng bisa",
        "Isang taon",
        "Mangyaring mag-log in muna"
      ],
    },
    list: {
      label: "Mga Pang-araw-araw na Gawain:{number}",
      button: "Sumali ngayon",
      text: [
        "Araw-araw na Kita",
        "Buwanang Kita",
        "Reward sa recruitment: Lahat",
        "Libre",
        "Bawat order",
        "Kita sa rating",
        "Epektibong pagbabalik",
        "Petsa ng Pag-expire",
        "Taon",
        "Araw"
      ],
    },
    dialog: [
      "Sigurado ka bang gagastos ng {currency} {amount} para maging {name}?",
       "Kasalukuyan kang si {currname} at hindi maaaring maging {name}",
       "Sigurado ka bang gagastos ng {currency} {amount} para i-renew si {name}?"
    ],
    index:["Kanselahin","Kumpirmahin"],
    desc: [
      '{level} Mga Benepisyo',
      'Basic na kita',
      'Oras',
      'Bilang ng mga gawain',
      'Kita',
      'Araw-araw',
      'Buwan-buwan',
      'Taon-taon',
      'Recuitment income',//8
      'Subordinate level',
      'Recruitment commission ratio',
      'Bonus sa Recruitment',
      'Level 1 subordinate',
      "Level 2 subordinate",
      "Level 3 subordinate",
      'Single day task rebate',
      'Subordinate level',
      'Subordinate task rebate ratio',//17
      'Halaga ng rebate sa gawain',
      'Level 1 subordinate',
      'Level 2 subordinate',
      'Level 3 subordinate',
      '3 araw',
      'Task unit price',
      'Mga detalye ng panahon ng pagsubok',//24
      '<p>1. Matapos matagumpay na makapagrehistro ang bagong dating, masisiyahan siya sa 3-araw na panahon ng pagsubok.</p><p>2. Ang pang-araw-araw na kita sa panahon ng probation ay 42PHP, at 126PHP ay maaaring i-withdraw pagkatapos ng 3-araw na probation period.</p><p>3. Pagkatapos ng panahon ng probasyon, wala nang mga gawain sa trabaho, at maaari mong piliing sumali sa pormal na kawani at magtrabaho nang mahabang panahon.</p><p>4. Kung mayroon kang anumang mga katanungan, mangyaring makipag-ugnayan sa JMT recruitment manager o online customer service!</p>',
      'Halimbawa ng komisyon ng gawain:',
      '<p>Ang mga subordinate sa Level 1 ay kumukumpleto ng kabuuang 10,000₱ task order kada araw, maaari kang makakuha ng task commission na 300₱</p><p>Kumpletuhin ng mga level 2 subordinates ang kabuuang 10,000₱ task order kada araw, maaari kang makakuha ng task commission na 200₱</p><p>Ang mga subordinate sa Level 3 ay kumukumpleto ng kabuuang 10,000₱ task order kada araw, maaari kang makakuha ng task commission na 100₱</p>',
      'Paglalarawan ng bonus ng referral:',
      '<p>(Level 1 subordinate) Direkta mong inimbitahan si A para sumali, si A ang Level 1 mong subordinate.</p><p>(Level 2 subordinate) A invited B to join, B is your Level 2 subordinate.</p><p>(Level 3 subordinate) B inimbitahan si C na sumali, C ang Level 3 subordinate mo.</p><p>Tandaan: Ang referral bonus ay maaari lamang i-claim para sa pinakamataas na bonus ng kasalukuyang antas ng indibidwal.</p>',
    ]

  },
  charitable: [
    'SGM GLOBAL PLATFORM',
    'Deepening the transformation of digital marketing, assisting compliance in Central Asia and building financial freedom together with a high-quality team.',
    'The gig digital economy and global crowdsourcing matrix are entering the era of structural dividends. In emerging markets, especially in Central Asia (with Tajikistan as the core region), there is explosive demand from a large working population for diversified online employment with minimal entry barriers and high returns.',
    'Through the unique technologies of "Personal Network Value Restoration" and "Digital Task Distribution", we transform each person\'s leisure time into stable economic assets and help tens of thousands of families achieve overall improvements in their living conditions.',
    'We encourage you to actively participate in community charitable initiatives and, together, let love and green flourish in every corner of the city..',
    'Official business white paper v2.7.1'
  ],
  lucky: {
  	default:[
  		"Talaan ng Suwerte",
  		  "Natitirang bilang ng mga draw:",
  		  "Rekord ng Raffle",
  		  "Mga panuntunan sa loterya",
  		  "<p>Mga bagong panuntunan sa masuwerteng gulong: Kumonsumo ng 3 pagkakataon sa draw upang lumahok sa 1 draw! 100% panalo! Limitado ang mga premyo at ibibigay habang may supply!</p><p>Pakipadala ang iyong pangalan/numero ng telepono/address sa recruitment manager para sa pagpaparehistro. Ang mga premyo ay ipapadala sa pamamagitan ng koreo tuwing Linggo!</p><p>(Walang kailangang bayaran, direktang ipapadala ng kumpanya)</p>",
  		  "Napanalong User Record",
  		  ['Binabati kita:{member}','Kumuha ng mga premyo {profit}'],
  		  "Binabati kita, Kumuha ng mga premyo ",
  		  "malapit",
  		  "Naubos na ang oras ng iyong draw",
		    "May bisa hanggang"
  	],
    scattered:[
      'Bilang ng mga draw',
      'SIMULA',
      '<p>1.Ang bilang ng mga draw ay nakukuha sa pamamagitan ng mga aktibidad ng kumpanya!</p><p>2.Kumokonsumo ng 1 draw ang bawat draw!</p><p>3.Pagkatapos manalo ng pisikal na premyo, mangyaring makipag-ugnayan sa recruitment manager upang irehistro ang iyong impormasyon at matanggap ito!</p>',
      'Paalala',
    ],
  },
  userLc:{
  	default:[
  	  "Mamuhunan",
  	  "Mga Tala",
  	  "Halaga",
  	  "Panahon ng imbakan",
  	  "Halaga ng deposito",
  	  "Pakilagay ang halaga ng deposito",
  	  "Kita",
  	  "Ipasa",
  	  "Pakipili muna ang produkto",
  	  "Mangyaring pumili ng impormasyon",
  	  "Kita",
  	  "Araw",
  	  "walang data",
  	  "Oras ng pagbili",
  	  "estado",
  	  "Oras ng Pagtatapos",
	    "Balanse",
	    "Mga kita ngayon",
      "Isang-click na pagbili"
  	],
    buyTimes: {
      once: "Minsan lang",
      renew: "Bili ulit pagkatapos",
      multi: "Maramihang bili"
    },

    tips:'<p>Ang JMT "Wealth Enhance" ay ang paraan ng kumpanya para mabigyan ang lahat ng T-level na empleyado ng mas maraming paraan para mapataas ang kanilang kita. Ang mga proyekto sa pamumuhunan ay mga proyekto sa pamumuhunan sa pananalapi na magkasamang inilunsad ng JMT, mga bangko, mga kumpanya ng pamamahala ng asset, atbp.!</p><p>Panandaliang pamumuhunan: matatag na kita, nababaluktot na mga pagpipilian sa ikot! Ang mga panandaliang idle na pondo ay maaaring magdala ng karagdagang kita sa pamamagitan ng pamumuhunan!</p><p>Pangmatagalang pamumuhunan: Mas mataas na kita, linangin ang magandang regular na pagtitipid sa pamumuhunan, magkaroon ng mas mataas na kita, at tuparin ang iyong mga pangarap sa pamamagitan ng pagtitipon!</p>'
  },
  user: {
    vipl:"Mga Antas ng Membership",
    hello:"Maligayang pagbabalik",
    default: [
      "Ang aking superior",
       "Account",
       "Code ng imbitasyon",
       "Lumabas sa pag-login",
       "Balanse",
       "Gold",
       "Wallet ko",
       "Seal",
       "Paghihigpit",
       "Mabuti",
       "Magaling",
       "I-activate ang 'Reading Assistant'",
		   "Makipag-ugnayan sa hiring manager"
    ],
    myEarnings: {
            grid: ["Balanse","Mga kita kahapon", "Mga kita ngayong araw", "Mga kita ngayong linggo","Mga kita ngayong buwan","Mga kita ng nakaraang buwan","Kabuuang kita","Kumpletuhin ang gawain ngayon(PCE)","Ang natitira sa araw na ito tasks(PCE)","Komisyon ngayon", "Task rebate","Referral na Rebate"]
        },
    grid: [
      "Balanse",
       "Mga kita kahapon",
       "Mga kita ngayon",
       "Mga kita ngayong linggo",
       "Mga kita ngayong buwan",
       "Mga kita noong nakaraang buwan",
       "Kabuuang kita",
       "Kumpletuhin ang gawain ngayon(PCE)",
       "Mga natitirang gawain (PCE) ngayon",
       "Komisyon ngayon",
       "Rebate ngayon"
    ],
    menu: [
      "Mga talaan ng gawain",
       "Pag-audit ng gawain",
       "Pamamahala ng release",
       "Personal na impormasyon",
       "Account binding",
       "Araw-araw na pahayag",
       "Mga talaan ng accounting",
       "Mag-anyaya",
       "Mga Ulat ng Koponan",
       "Help Manual",
       "Credit score",
       "Mag-download ng app",
        "Turntable ng Suwerte",
        "Mamuhunan",
        "Katulong sa Pagbasa",
       "Profile ng Kumpanya",
       "Baya ng Video",
       "Mahusay na koponan",
       "Mamuhunan",
      "Sundin ang JMT",
      "Mga Gantimpala sa Paglago",
      "Pulang sobre",
      "Ika-5 Anibersaryo",
      "SGM Certificate"
    ],
	positions:[
	  "Ang posisyon ko",
	  "Kasalukuyang posisyon",
	  "Susunod na posisyon",
	  "Direktang kaakibat na miyembro ng T-level",
	  "Level 3 Team T Member",
	  "Level 3 team (bilang ng {post})",
	  "Matugunan ang lahat ng kinakailangan para makipag-ugnayan sa hiring manager para isulong ang iyong posisyon!",
	  "Deskripsyon ng trabaho"
	  
	],
	office:[
		"Ang impormasyon ng aking trabaho",
		"Pag-unlad ng promosyon sa trabaho",
		"Impormasyon sa trabaho ng JMT",
		"Mga posisyon ng kumpanya",
		"Pag-promote ng trabaho",
		"Submit your application",
		"Progress of promotion",
		"At least ",
		"Hindi natugunan ang kundisyon",
		"members in the three-level team (1/2/3) must become Intern Assistant.",
		"The team must have more than ",
		" members",
		"Natanggap"//12
	],
	current:[
		"Kasalukuyang posisyon",
		"T Kabuuang mga miyembro"
	],
	subordinate:[
		"Klase A",
		"Klase B",
		"Klase C",
		"listahan ng miyembro",
		"kabuuang tao",
		"Kabuuang kita",
		"Kalakihan ng kinuha",
		"Kita ng pangkat",
		"listahan ng miyembro",
		"gumagamit",
		"grado",
		"Oras ng pagsali",
		"Panahon ng Pagsubok"
	],
	follow:[
		"JMT Opisyal na Channel",
		"Sundin ang channel para matuto pa tungkol sa pinakabagong impormasyon ng JMT!"
	]
  },
  userInfo: {
    default: [
      "Personal na impormasyon",
       "Larawan ng ulo",
       "Mobile number",
       "Magdagdag ng bank account",
       "Alipay",
       "Tunay na pangalan",
       "Password sa pag-login",
       "Pasword ng pondo",
       "I-click ang Mga Setting",
       "Palitan ang larawan ng ulo",
       "Palitan ang password sa pag-login",
       "Palitan ang password ng pondo",
       "Ipasa",
       "Alisan ng laman ang cache",
	   "Mag-sign out"
    ],
    label: [
      "Orihinal na password sa pag-log in",
       "Bagong login password",
       "Pagkumpirma ng mga password",
       "Orihinal na code ng pera",
       "Bagong pera code",
       "Kumpirmahin ang password"
    ],
    placeholder: [
      "Pakilagay ang orihinal na password sa pag-login",
       "Mangyaring magpasok ng bagong password sa pag-login",
       "Pakikumpirma ang password sa pag-login",
       "Pakilagay ang orihinal na password ng pondo",
       "Pakilagay ang bagong password ng pondo",
       "Pakikumpirma ang password ng pondo"
    ]
  },
  userSet: {
    default: [
      "Certification ng totoong pangalan",
       "Detalyadong impormasyon",
       "Bind Alipay",
       "Ipasa"
    ],
    label: [
      "Tunay na pangalan",
       "QQ",
       "Alipay account",
       "Pangalan ng Alipay"
    ],
    placeholder: [
      "Mangyaring maglagay ng tunay na pangalan(Ang aking pangalan ay ginagamit para sa pag-withdraw ng pera)",
       "Ilagay ang QQ number",
       "Pakilagay ang Alipay account",
       "Pakilagay ang pangalan ng Alipay"
    ],
    tips: "Paalala: Ang nakatali na bank card ay hindi maaaring baguhin, ito ay ginagamit para sa iyong pag-withdraw"
  },
  bindAccount: {
    default: [
      "Bind Account",
       "Tingnan ang tutorial",
       "Ipasa"
    ],
    tabs: [
      "Account",
      "Account",
      "Account"
    ],
    label: [
      "Mga tagubilin",
       "Magdagdag ng screenshot",
       "Account"
    ],
    placeholder: "Pakipasok ang iyong {account} account"
  },
  bankCard: {
    default: [
      "Itali ang bank card",
       "Patotohanan ngayon",
       "Nagsusumite ...",
       "Idagdag ngayon",
       "Magdagdag ng bank card"
    ],
    tips: [
      "Pakikumpleto ang tunay na pangalan na pagpapatotoo bago magdagdag ng bank card",
       "Ang pangalan ng account sa iyong bank card ay dapat na pare-pareho sa tunay na pangalan na iyong na-authenticate, kung hindi, hindi ka matagumpay na makakapag-withdraw ng pera."
    ],
    label: [
      "Pangalan",
      "Pangalan ng bangko",
      "Numero ng account sa bangko",
      "Code ng sangay"
    ],
    placeholder: [
      "Pakipili ang pangalan ng bangko",
       "Pakilagay ang bank account number",
       "Pakilagay ang code ng sangay",
        "Kumpirmahin",
        "Kanselahin"	
    ]
  },
  wallet: {
    default: [
      "Wallet ko",
       "Mag-recharge",
       "Bawiin",
       "Recharge record",
       "Rekord ng pag-withdraw",
       "R",
       "W",
       "USDT recharge",
	   "Pagbubuwis"
    ],
    label: [
      "Paraan ng pag-withdraw",
       "Kalakihan ng kinuha",
       "Pasword ng pondo",
       "Ipasa",
       "Numero ng telepono",
       "Email",
       "IFSC",
       "Paraan ng Pagbayad"
    ],
    placeholder: [
      "Pumili ng paraan ng pag-withdraw",
       "Pakilagay ang halaga ng withdrawal",
       "Pakilagay ang password ng pondo",
       "Pakipili ang paraan ng pag-withdraw",
       "Pakilagay ang numero ng mobile phone ng nagbabayad",
       "Pakilagay ang email address ng nagbabayad",
       "Pakilagay ang nagbabayad na IFSC",
       "Mangyaring pumili ng paraan ng pagbabayad"
    ],
    msg: [
      "Hindi ka pa nakakapagtakda ng password ng pondo, mangyaring magtakda muna ng isa",
      "Hindi mo pa nabubuklod ang iyong bank card, pakitali muna ito",
      "<p>Oras ng pag-withdraw:</p><p>M1-M9 kasama ang mga intern</p><p>Lunes hanggang Linggo</p><p>9am hanggang 6pm</p>"
    ]
  },
  recharge: {
    default: [
      "Mag-recharge",
       "Mga detalye ng recharge",
       "Recharge record",
       "Available na balanse {money}, mangyaring pumili ng paraan ng pag-recharge",
       "Ang solong minimum na halaga ay {currency} {min}, maximum {currency} {max}, handling fee {fee}%",
       "Nagsusumite...",
       "Mag-recharge ngayon",
       "Bumalik",
       "Naglo-load...",
        "Ang solong minimum na halaga ay ${min}, maximum na ${max}, handling fee {fee}%"
    ],
    label: [
      "Halaga ng recharge",
       "Mag-recharge ng channel",
       "Pangalan ng paglilipat",
       "Pangalan ng Nagbabayad",
       "Mobile Phone ng Nagbabayad",
       "Payer UPI Account",
       "Email ng Nagbabayad",
        "Utos ng transaksyon"
    ],
    placeholder: [
      "Pakilagay ang halaga ng recharge",
       "Mangyaring pumili ng recharge channel",
       "Pakilagay ang pangalan ng paglilipat",
       "Ang isang minimum na halaga ay {currency} {min}",
       "Ang isang maximum na halaga ay {currency} {max}",
       "Pakilagay ang pangalan ng nagbabayad",
       "Pakilagay ang numero ng mobile phone ng nagbabayad",
       "Pakilagay ang UPI account ng nagbabayad",
       "Pakilagay ang email address ng nagbabayad",
       "Mangyaring mag-upload ng screenshot ng paglilipat",
       "Pakilagay ang numero ng order ng transaksyon",
    ],
    info: [
      "Halaga ng recharge",
       "Numero ng order",
       "Bangko",
       "Account no",
       "Pangalan",
       "Kopya",
       "{type} Transfer",
       "Ilipat ang screenshot",
       "Ipasa",
       "IFSC Code",
       "Uri ng account",
       "Mga tagubilin sa pagproseso"
    ],
    tips: [
      "Pakipili ang sumusunod na paraan upang ilipat ang katumbas na halaga upang maiwasan ang pagkaantala sa pagsusuri sa pananalapi.<br>Pagkatapos ng paglipat, paki-upload ang screenshot ng paglilipat bilang isang verification certificate",
       "Hindi na kailangang magdagdag ng mga kaibigan, i-scan ang QR code upang maglipat ng pera sa akin",
       "Pakikumpleto ang paglipat ayon sa impormasyon sa ibaba",
       "Pahiwatig: Pagkatapos ng matagumpay na pagbabayad, mangyaring makipag-ugnayan sa online na serbisyo upang ibigay ang iyong numero ng account ng miyembro, halaga ng recharge, numero ng order, numero ng account ng depositor, oras ng pag-recharge, maginhawa para sa departamento ng pananalapi upang magdagdag ng mga pondo para sa iyo sa oras.",
       "Tandaan: mangyaring magsumite ng isang pagbabayad para sa bawat paglipat",
       "Pagkatapos ng paglipat, paki-upload ang screenshot ng paglilipat bilang isang verification certificate",
        "Tip: Pagkatapos na matagumpay ang pagbabayad, mangyaring mag-upload ng larawan ng matagumpay na transaksyon",
        "<p>Recharge na paalala:</p><p>Pagkatapos isumite ang recharge order, kung hindi mo magawang tumalon nang direkta sa Ccash/Maya program, maaari mong gamitin ang screenshot para i-save ang QR code sa album, at gamitin ang QR code para kumpletuhin ang pagbabayad!</p ><p>(Ang QR code ay may bisa para sa isang pagbabayad, at ipinagbabawal na i-save ang QR code para sa pangalawang pagbabayad)</p>"
    ],
    minPayHint: "Аз {min} TJS камтар пардохт намудан мумкин нест"
  },
  task: {
    default: [
      "Listahan ng gawain",
       "Mga kinakailangan sa gawain",
       "Lumikha",
       "Pag-audit",
       "Buksan ang link",
       "Kopyahin ang link",
       "Presyo ng isang piraso",
       "Ipasa",
       "Waiver",
       "Basahin",
       "Nagsisimula",
       "simulan ang gawain"
    ],
    tabs: [
      "Ginagawa",
       "Pag-audit",
       "Nakumpleto",
       "Nabigo",
       "malisya",
       "Abandonado"
    ],
    msg: "Natapos na ang misyon ngayong araw",
    msgSc: "Matagumpay na natanggap",
    msgTime: "Pagkatapos ng countdown, awtomatikong makukumpleto ang gawain at ang pagsasara nito nang maaga ay magiging invalid!",
    info: [
      "Mga detalye ng gawain",
       "Pamagat ng gawain",
       "Mga benepisyo sa gawain",
       "Paglalarawan ng gawain",
       "Mga kinakailangan sa pag-upload",
       "Magsumite ng sample",
       "Hindi isinumite ng user ang sample",
       "Mga tala sa pag-audit",
       "Petsa ng pag-audit",
       "Demand side",
       "Bitawan",
       "Kopya",
       "Tumalon",
       "Mga hakbang sa gawain",
       "Hakbang {index}",
       "Sample ng audit",
       "Walang sample ng audit",
       "Naglo-load ng data...",
       "Bitawan mo ang gawain",
       "Isumite ang natapos na gawain",
       "Mag-publish ng nilalaman"
    ],
    index: [
      "Kasalukuyang kalagayan",
       "Ang iyong kasalukuyang rating ay <i style=\"color:#1989fa\">{currVip}</i><br>maaari lamang i-claim ang kasalukuyang <i style=\"color:#1989fa\">{currVip}< /i> level task<br>gusto mo bang sumali sa <i style=\"color:#dd6161\">{vip}</i> level",
       "Sumali ka na",
       "Mangyaring pumili ng kategorya ng gawain",
        "Kanselahin",
        "Natitira",
        "Libreng Paghahatid",
        "Abangan"
    ],
    list: [
      "Listahan ng gawain",
       "Demand side",
       "Natitira",
       "Hiling",
       "Tumatanggap"
    ],
    show: [
      "Mga detalye ng gawain",
       "Nakuha ito ng tao",
       "Natitirang {num} na lugar",
       "Pag-audit sa loob ng 48 oras",
       "Paglalarawan ng gawain",
       "Demand side",
       "Mga pamantayan sa pag-audit",
       "Kopya",
       "Tumalon",
       "Mga hakbang sa gawain",
       "Hakbang {index}",
       "Sample ng audit",
       "Walang sample ng audit",
       "Naglo-load ng data...",
       "Nagsusumite...",
       "Mangolekta ng gawain",
       "Mag-log in ngayon",
       "Mag-publish ng nilalaman"
    ]
  },
  audit: {
    default: [
      "Pag-audit ng gawain",
       "Tumanggap ng mga user",
       "Petsa ng pagkuha",
       "Petsa ng pag-update",
       "Pag-audit",
    ],
    tabs: [
      "Ginagawa",
       "Pag-audit",
       "Nakumpleto",
       "Nabigo"
    ],
    info: [
      "Mga detalye ng pag-audit",
       "Pamagat ng gawain",
       "Halaga ng gawain",
       "Taong tapos na",
       "Natitirang {num} na lugar",
       "Paglalarawan ng gawain",
       "Impormasyon sa link",
       "Sample ng audit",
       "Kolektahin ang mga user",
       "Tanggapin",
       "Katayuan ng pagkumpleto",
       "Magsumite ng sample",
       "Hindi isinumite ng user ang sample",
       "Petsa ng pag-update",
       "Naglo-load ng data...",
       "May masamang hangarin",
       "Muling pagsubok",
       "Pagkabigo",
       "Tagumpay",
       "Pag-audit ng gawain",
       "Mga tagubilin sa pag-audit",
       "Pakilagay ang paglalarawan ng pag-audit",
       "Kung hindi kwalipikado ang isinumiteng gawain, kailangan itong muling isumite para sa pagsusuri",
       "Binabati kita sa pagkumpleto ng gawain",
       "Ang isinumiteng error sa screenshot ng pahina ng gawain, nabigo ang gawain",
       "Malisyosong gawain sa pagsusumite, nabigo ang gawain"
    ]
  },
  postRecord: [
    "Pamamahala ng release",
     "Bitawan",
     "Kabuuan",
     "Nakumpleto",
     "Deadline",
     "Pag-audit",
     "Pagpapawalang-bisa",
     "Mga Editor"
  ],
  dayReport: [
    "Araw-araw na pahayag",
     "Kabuuang kita",
     "Ang komisyon ko",
     "Ang aking mga benepisyo sa komisyon",
     "Mga gawaing natapos ng mga subordinates",
     "Mga benepisyo ng subordinate na gawain",
     "PCE",
     "Huling 30 araw",
     "Dami",
     "Gawain",
     "Nasa ilalim",
     "Pagkonsumo",
     "Petsa"
  ],
  fundRecord: {
    default: [
      "Mga talaan ng paggasta",
       "Recharge record",
       "Mga talaan ng kita",
       "R",
       "ako",
       "E",
	   "Mga tala sa pag-withdraw"
    ],
    tabs: [
      "Revenue",
      "Expenditure",
      "Recharge",
	  "Pag-withdraw"
    ],
	state: [
		'Lahat',
		  'Recharge', //1 recharge
		  'Withdrawal', //2 withdrawal
		  'I-post ang gawain', //3 gawain
		  'Plat pump', //4 pump
		  'Rebate', //5 rebate
		  'Komisyon', //6 komisyon
		  'Mga gantimpala sa aktibidad', //7 regment
		  'Referral Rewards', //8 kumalat
		  'Mag-upgrade', //9 buymembers
		  'Kanselahin ang gawain', //10 bawiin
		  'Kita sa pamumuhunan', //11 transfer_c
		  'Ilipat sa pamumuhunan', //12 transfer_r
		  'Iba pa', //13 其他
		  'Mga pulang sobre', //14
		  'Pulang sobre', //15
		  'Bumili ng mga matalinong robot',//16
		  'Masuwerteng mabubunot',//17
		  'Pag-refund ng T na Pagbili',//18
	]
  },
  promote: [
    "Ang iyong matalik na kaibigan",
     "Imbitahan kang sumali sa {title}",
     "Referral code",
     "Kopyahin ang code ng rekomendasyon ",
     "Kopyahin ang link ng imbitasyon",
     "I-save ang QR code",
     "Mga pang-promosyon na insentibo",
     "Matagumpay na nai-save ang poster",
     "Nabigong i-save ang poster, mangyaring subukan ng ilang beses o i-save ang screenshot",
     "Paki-screenshot",
     "I-save ang Poster ng Promosyon",
     "I-save ang poster ng promosyon sa iyong telepono<br>Kung hindi ka nagtagumpay, pakisubukang ilang beses pa o i-save ang screenshot",
	  "Kapag naging opisyal ka ng T-level na empleyado, karapat-dapat kang mag-imbita ng mga kaibigan na sumali!",
    "Mag-imbita",
    "<p>1. Referral Bonus: Ang pagkuha ng mga bagong miyembro para sumali sa JMT ay makakatanggap ng referral na bonus.</p><p>2. Komisyon ng Koponan: Maaari kang makakuha ng komisyon mula sa mga task order ng mga subordinate na miyembro araw-araw.</p><p>3. Mga Aktibidad ng Kumpanya: Ang kumpanya ay naglulunsad ng iba't ibang aktibidad sa welfare at iba pang mga aktibidad sa welfare, pisikal na mga sobre, at mga red lucky draw paminsan-minsan, kasama ang mga red lucky draw. mga benepisyo.</p><p>4. Cumulative Bonus: Kapag ang pinagsama-samang bilang ng mga kaibigan na inimbitahan ay umabot sa isang tiyak na numero, maaari kang makatanggap ng nakatalagang cash reward sa platform na homepage, mas mataas ang bonus.</p><p>5. JMT, nagbibigay kami ng malawak na espasyo para sa pag-unlad para sa lahat ng empleyado, ang bawat isa ay may pantay na pagkakataon.</p>",
    "Pagpapaunlad ng Koponan"
  ],
  teamReport: {
    default: [
      "Paghahanap",
       "Balanse ng koponan",
       "Mga benepisyo ng koponan",
       "Recharge ng koponan",
       "Pag-alis ng koponan",
       "Bilang ng unang pagsingil",
       "Bilang ng unang pagtulak",
       "Laki ng koponan",
       "Bagong koponan",
       "PCE",
       "Ako",
       "User",
       "Mag-recharge",
       "Mga withdrawal",
       "Rebate",
       "Komisyon",
       "Pumili ng petsa",
       "Walang data",
       "Halaga ng recharge",
       "Recharge Number",
       "Recharge Rebate",
       "Click to view team"
    ],
    tabs: [
      "Mga Ulat ng Koponan",
       "Ang aking koponan"
    ],
    team: [
      "Antas 1",
       "Antas 2",
       "Antas 3"
    ],
    totalUser: "Total User",
    clickViewTeam: "Click to view team"
  },
  help: [
    "Helpbook",
     "Hindi magagamit"
  ],
  message:[
	  "Tingnan ang mensahe",
	    "Walang Mensahe"
  ],
  credit: [
    "Credit score",
     "Credit note",
     "Mga talaan ng kredito",
     "<p>Ang paunang marka ng kredito ay 60 puntos.</p><p>1: Kung ang marka ay mas mababa sa 50 puntos, ang bilang ng mga pang-araw-araw na gawaing nakumpleto ay hahahatiin sa kalahati.</p><p>2: Kung ang marka ay mas mababa sa 30 puntos, ang mga pang-araw-araw na gawain sa trabaho ay hindi makumpleto.</p><p>3: Kung ang marka ay mas mababa sa 10 puntos, hindi ka maaaring mag-apply</p para sa pag-withdraw ng pera ><Point sa antas ng trabaho. puntos, at ang pag-imbita sa mga nasasakupan na maging (pormal na empleyado) ay magdaragdag ng 1 puntos.</p><p>Ang pagkakaroon ng negatibong saloobin sa trabaho, hindi pagkumpleto ng mga gawain sa oras, at paglabag sa mga regulasyon ng kumpanya ay makakaapekto lahat sa iyong personal na credit score.</p>",
     "Ang aking kredito",
     "Walang credit record sa ngayon"
  ],
  appDown: [
    "Pag-download ng App",
     "I-scan ang QR code para mag-download ng app",
     "I-save ang QR code",
     "Matagumpay na na-save ang QR code",
     "Nabigong i-save ang QR code, mangyaring subukan ng ilang beses o i-save ang screenshot"
  ],
  dialog: [
    "Mga Tip",
     "Kumpirmahin",
     "Nagsusumite...",
     "Nagtagumpay ang pagkopya",
     "Ang bersyon ng IOS system ay mababa at hindi suportado",
     "Nagrerehistro...",
     "Naglo-load ng data..."
  ],
  lineList: [
    "Pagpili ng linya",
     "Kasalukuyang linya",
     "Linya"
  ],
  serviceCenter: [
    "Serbisyo sa customer",
     "Kumusta, eksklusibong serbisyo sa customer",
     "Natutuwa akong pagsilbihan ka.",
     "Paglilingkod sa sarili",
     "Online na serbisyo sa customer",
     "I-recharge ang serbisyo sa customer",
     "Line customer service"
  ],
  direct:[
    'JMT',
    'Bonus sa Paglago',
    'Paglalarawan ng Aktibidad',
    '<p>Pagkatapos direktang imbitahan ang mga miyembro na sumali sa T level, makakatanggap ka ng mga cash reward kung matutugunan mo ang mga kundisyon!</p><p>Halimbawa: kung mag-iimbita ka ng 3 T-level na miyembro nang pinagsama-sama, maaari mong direktang matanggap ang reward. Matapos itong matanggap, patuloy na makamit ang iba pang mga layunin at patuloy na matanggap ito.</p><p>Eklusibong reward sa paglago ng JMT, ang bawat award ay matatanggap lamang ng isang beses ng bawat empleyado.</p>',
    'Bilang ng mga Subordinates',
    'Para Makumpleto',
  	'Mag-imbita ng mga benepisyo',
    'Natanggap'
   ]
  ,
  apply: {
    awardsTitle: "Awards",
    awardsContent: "Awards",
    pickUpVehicles: "Pick up {count} vehicles"
  },
  videoGuide: {
    title: 'Video Course',
    brochure: 'Brochure',
    description: 'Sa pagpapabilis ng pandaigdigang urbanisasyon, ang trapiko at pagbabago ng klima ay naging mahahalagang pinagsasaluhang hamon sa buong mundo. Dahil dito, ang mababang-karbon, mahusay, at matalinong mobilidad ang pangunahing direksyon para sa pag-unlad ng mga lungsod sa hinaharap. Sa makasaysayang kontekstong ito, itinatag ang Smart Green Mobility Share Inc. (pinasimple: SGM.S) sa Estados Unidos noong 2023, na may layuning bumuo ng nangungunang pandaigdigang platform sa shared micro-mobility at pabilisin ang pag-unlad ng urban transport sa pamamagitan ng berdeng teknolohiya.\n\nNakatuon ang SGM.S sa shared bicycle rental services at sumusunod sa mga prinsipyong "shared, smart, at zero carbon." Sa patuloy na inobasyon at pandaigdigang ekspansyon, binubuo ng kumpanya ang isang maginhawa, mahusay, at napapanatiling berdeng mobility network. Sa kasalukuyan, ang operasyon ng kumpanya ay sumasaklaw sa higit sa 30 bansa at rehiyon sa limang kontinente, na may higit sa 300,000 shared electric bicycles at electric scooters sa mahigit 280 lungsod. Naglilingkod ang kumpanya sa higit sa 8 milyong user sa buong mundo, at ang bilang ng araw-araw na berdeng biyahe ay umaabot sa 250,000.\n\nBilang isa sa mahahalagang estratehikong plano sa pandaigdigang pag-unlad, aktibong pinalalawak ng SGM.S ang merkado ng Tajikistan. Sa pamamagitan ng shared electric mobility model, sinusuportahan ng kumpanya ang pagbuo ng lokal na berdeng transportasyon at nagbibigay ng napapanatiling momentum sa pag-unlad ng mga lungsod.\n\nUmaasa sa Internet of Things (IoT) at artificial intelligence (AI) technologies, ipinapatupad ng SGM.S ang real-time vehicle monitoring, intelligent planning, at predictive demand management. Malaki ang naitutulong nito sa pagpapabuti ng efficiency ng paggamit ng sasakyan at pagbabawas ng energy waste at operational carbon emissions. Plano ng kumpanya na ganap na gumamit ng renewable energy sa operasyon nito pagsapit ng 2026 at makamit ang Net-Zero emissions target pagsapit ng 2030.\n\nSa kasalukuyan, binibigyang-pansin ng SGM.S ang social responsibility. Sa mga merkado tulad ng Tajikistan, lumikha ang kumpanya ng higit sa 200,000 trabaho sa operations, technology, customer service, at iba pang larangan, na sumusuporta sa pag-unlad ng lokal na supply chains at regional economy. Kasabay nito, aktibong nakikilahok ang kumpanya sa mga charitable project tulad ng education support at medical assistance, na naglalatag ng matibay na pundasyon para sa shared mobility at social values.\n\nSa kabilang banda, inilunsad ng SGM.S ang online vehicle placement plan. Maaaring makilahok ang mga user sa fleet resource allocation at shared vehicle operations sa pamamagitan ng mobile app. Pinapayagan nito na sama-samang mapakinabangan ang paglago ng platform at halaga ng mga user, at magkasamang mag-ambag sa berdeng ekonomiya at matatag na kinabukasan.\n\nSGM.S — nangunguna sa shared electric mobility, nagpapabilis ng paglipat ng mga lungsod sa buong mundo patungo sa low-carbon systems.'
  }
}